<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-v-title">
      {{$t('maintenance.risk_categories.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-v-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-v-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-v-name-label">
                  {{ $t('maintenance.risk_categories.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-v-form-name"
                  type="text"
                  v-model="vForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.risk_categories.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-v-description-label">
                  {{ $t('maintenance.risk_categories.create.description_label') }}
                </label>
                <b-form-textarea
                  qid="create-v-form-description"
                  v-model="vForm.description"
                  rows="6"
                  max-rows="6"
                  required
                  :placeholder="$t('maintenance.risk_categories.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-v-cancel-button"
              >
                {{ $t('maintenance.risk_categories.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-v-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.risk_categories.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: 'CreateRiskCategory',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.risk_categories.title'),
            to: '/maintenance/risk-categories'
          },
          {
            text: this.$t('maintenance.risk_categories.create.title'),
            active: true
          }
        ],
        vForm: {
          name: '',
          description: '',
          client:'',
        },
        error: '',
        inputLink: '',
        selectedFiles: [],
        timeLimitItems: [],
        timeLimitInput: '',
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/risk-categories')
      },
      formSubmit(evt) {
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.vForm.name);
        formData.append("description", this.vForm.description);
        formData.append("client", this.getClient.slug);


        if (this.vForm.name && this.vForm.name.length) {
          this.buttonDisabled = true;
          piincHttp.post('/risk-categories', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.risk_categories.create.success'))
            self.buttonDisabled = false;
            self.goToList();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = ''

          if (!this.vForm.name.length) {
            this.error +=  ' ' + this.$t('system.name_error_message')
          }
        }

      },
    },
    components: {

    },
    created () {
      if (this.getClient && this.getClient.slug) {

      }
    }
  }
</script>
